import React, { ReactNode, useEffect, useRef } from "react";

export type AccordionListProps = {
  children: ReactNode;
  className?: string;
};

export const AccordionList = ({ children, className }: AccordionListProps) => {
  const parentRef = useRef<HTMLDivElement>();
  // Ensure only one accordion drawer is open at a time
  useEffect(() => {
    const parent = parentRef.current;
    const details = parent.querySelectorAll("details");

    const onClick = (e) => {
      const { currentTarget } = e;
      details.forEach((detail) => {
        if (detail !== currentTarget) {
          detail.removeAttribute("open");
        }
      });
    };

    // Close other drawers when one drawer is open
    [].forEach.call(details, (el) => {
      el.addEventListener("click", onClick, false);
    });

    // Cleanup
    return () => {
      [].forEach.call(details, (el) => {
        el.removeEventListener("click", onClick, false);
      });
    };
  });
  return (
    <div ref={parentRef} className={className}>
      {children}
    </div>
  );
};
